import { NgModule } from '@angular/core';
import { CxpRoutingModule } from './cxp-routing.module';
import { CxpStateModule } from './cxp-state.module';

@NgModule({
  imports: [
    // CxpTasksState is imported on a root level until header counter is independent from this state.
    CxpStateModule,
    CxpRoutingModule,
  ],
})
export class CxpModule {}
